import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: number;
}

/** Marque institutionnelle de la plateforme. */
export function Logo({ className, size = 36 }: LogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={cn('shrink-0', className)}
      role="img"
      aria-label="LMS Academy"
    >
      <rect width="64" height="64" rx="14" className="fill-primary" />
      <path
        d="M14 44V20h10.5c7.2 0 12 4.6 12 12s-4.8 12-12 12H14zm7-6h3.2c3.6 0 5.8-2.3 5.8-6s-2.2-6-5.8-6H21v12z"
        className="fill-primary-ink"
      />
      <circle cx="45" cy="26" r="6" className="fill-accent" />
      <path d="M39 44c0-3.9 2.7-7 6-7s6 3.1 6 7H39z" className="fill-accent" />
    </svg>
  );
}
